import { memo } from 'react'
import { sanitizeHTML } from 'src/utils/sanitizeHTML'

import './styles.scss'

type TechnicalInformationProps = {
  contentOne?: string | null
  contentTwo?: string | null
}

const TechnicalInformation = ({
  contentOne,
  contentTwo,
}: TechnicalInformationProps) => {
  return (
    <>
      {contentOne && (
        <article
          data-testid="productDocuments"
          className="productManualAndDocs
                w-full
                restructure-tablet:max-w-[350px]
                restructure-mobile:max-w-[296px]
                flex flex-row bg-white items-center mt-8
                border-solid border-[1px] border-primary rounded-lg justify-between px-6 py-4"
        >
          <div
            suppressHydrationWarning
            dangerouslySetInnerHTML={{
              __html: sanitizeHTML(contentOne),
            }}
          />
        </article>
      )}
      {contentTwo && (
        <article
          data-testid="productTechnicalInformation"
          className="product-technical-info
          flex flex-col
          px-8
          gap-y-10
          tablet:gap-y-8
          gap-x-10"
          suppressHydrationWarning
          dangerouslySetInnerHTML={{
            __html: sanitizeHTML(contentTwo),
          }}
        />
      )}
    </>
  )
}

export default memo(TechnicalInformation)
